export const PLANT_INFO = (t) => ({
  plantName: {
    key: "plantName",
    labelText: t("plantInformationStrings.plantName"),
  },
  plantLocation: {
    key: "plantLocation",
    labelText: t("plantInformationStrings.plantLocation"),
  },
  water_type: {
    key: "water_type",
    labelText: t("plantInformationStrings.waterType"),
  },
  num_trains: {
    key: "num_trains",
    labelText: t("plantInformationStrings.trainsNumber"),
  },
  tol_num_elements: {
    key: "tol_num_elements",
    labelText: t("plantInformationStrings.elementsNumber"),
  },
  dataset_name: {
    key: "dataset_name",
    labelText: t("plantInformationStrings.datasetName"),
  },
});
export const SELECTED_SECTION = (t) => ({
  sel_train: {
    labelText: t("addNewPlant.train"),
  },
  sel_pass: {
    labelText: t("addNewPlant.pass"),
  },
  sel_stage: {
    labelText: t("addNewPlant.stage"),
  },
  sel_pressure_vessels: {
    labelText: t("addNewPlant.noOfVessels"),
  },
  sel_element_involved: {
    labelText: t("addNewPlant.noOfElementsVessels"),
  },
  sel_element_type: {
    labelText: t("plantInformationStrings.elementType"),
  },
  is_dupont_element: {
    labelText: t("plantInformationStrings.is_dupont_element"),
  },
});
